import InputExtras from './InputExtras';

export default InputExtras;
